/**
 * Uses Google's implementation from the `android.util.Patterns` class.
 * Extended to filter out invalid Mailgun emails.
 *
 * If it's good enough for Google, then it's good enough for us.
 * */
export const isValidEmail = (email: string) => {
  if (!email || email.trim().length === 0) {
    return false;
  }

  // eslint-disable-next-line max-len
  // @see: https://android.googlesource.com/platform/frameworks/base/+/oreo-release/core/java/android/util/Patterns.java#428
  // @see https://www.ietf.org/rfc/rfc2822.txt
  const EMAIL_PATTERN =
    '^(?!mailto:)' + // no "mailto:" prefix
    '(?!.*[\\s,])' + // no spaces or commas anywhere
    '(?!.*\\\\$)' + // no ending backslash
    '[a-zA-Z0-9\\+\\.\\_\\%\\-\\+]{1,256}' + // user name
    '\\@' + // @ symbol
    '[a-zA-Z0-9][a-zA-Z0-9\\-]{0,64}' + // domain name
    '(' +
    '\\.' + // dot
    '[a-zA-Z0-9][a-zA-Z0-9\\-]{0,25}' + // top-level domain
    ')+' +
    '$';

  const emailRegex = new RegExp(EMAIL_PATTERN);
  return emailRegex.test(email);
};
